import { useNextQueryParam, useSetNextQueryParam, } from './useNextAppQueryString';
/**
 * Sync a filter value to query params in url
 */
export function useNextQueryFilter({ filterKey, onChange, }) {
    const filterValue = useNextQueryParam(filterKey, '');
    const setFilterValue = useSetNextQueryParam(filterKey);
    // const remove = useRemoveQueryStringValue();
    // if the filter hook unmounts, also remove from query
    // does not really work. especially if you navigate from search to KKH directly
    // useEffect(() => {
    //   return () => {
    //     if (
    //       window.location.pathname.includes('contacthistory') ||
    //       window.location.pathname.includes('requests') ||
    //       window.location.pathname.includes('evaluations')
    //     ) {
    //       remove(filterKey, {
    //         replaceHistory: true,
    //       });
    //     }
    //   };
    // }, []);
    const handleChange = (value) => {
        if (onChange) {
            onChange(value, filterKey);
        }
        else {
            setFilterValue(value);
        }
    };
    return { filterValue, handleChange };
}
